import keycloak from '../config/keycloak';

// Mock users: solo in sviluppo. In build NODE_ENV e' 'production' e il minifier elimina
// l'oggetto, cosi' credenziali e indirizzi non finiscono nel bundle pubblico.
const mockUsers = process.env.NODE_ENV === 'development' ? {
  admin: {
    id: 1,
    username: 'admin',
    password: 'admin',
    role: 'admin',
    firstName: 'Admin',
    lastName: 'User',
    email: 'admin@example.com',
    groups: ['admin'],
  },
  editor: {
    id: 2,
    username: 'editor',
    password: 'editor',
    role: 'editor',
    firstName: 'Editor',
    lastName: 'User',
    email: 'editor@example.com',
    groups: ['Editor'],
  },
  viewer: {
    id: 3,
    username: 'viewer',
    password: 'viewer',
    role: 'viewer',
    firstName: 'Viewer',
    lastName: 'User',
    email: 'viewer@example.com',
    groups: ['Viewer'],
  },
  operatore: {
    id: 4,
    username: 'operatore',
    password: 'GZ[nd=XLiLUwk9es',
    role: 'admin',
    firstName: 'serenissa',
    lastName: 'operatore',
    email: 'operatore@serenissima.com',
    groups: ['admin'],
  }
} : {};

class AuthService {
  async login(credentials) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const user = Object.values(mockUsers).find(u => 
      u.username === credentials.username && u.password === credentials.password
    );
    
    if (!user) {
      throw new Error('Invalid credentials');
    }
    
    const token = btoa(JSON.stringify(user)); // Simple mock token
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    
    return { user, token };
  }

  async register(userData) {
    throw new Error('Registration is not supported in mock mode');
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  async getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      throw new Error('No user found');
    }
    return JSON.parse(userStr);
  }

  isAuthenticated() {
    const token = localStorage.getItem('token');
    return !!token;
  }

  getUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }

  async refreshToken() {
    const user = this.getUser();
    if (!user) {
      throw new Error('No user found');
    }
    const token = btoa(JSON.stringify(user));
    localStorage.setItem('token', token);
    return { token };
  }
}

export default new AuthService(); 